var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawHouseSearchingN8Mp1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 534,
    height: 259,
    viewBox: "0 0 534 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119.453 221.655C175.118 221.655 220.243 178.294 220.243 124.807C220.243 71.3188 175.118 27.9583 119.453 27.9583C63.7881 27.9583 18.6628 71.3188 18.6628 124.807C18.6628 178.294 63.7881 221.655 119.453 221.655Z",
    stroke: "#FF9800",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeDasharray: "12 12"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M385.273 202.498C440.938 202.498 486.064 159.138 486.064 105.65C486.064 52.1619 440.938 8.80148 385.273 8.80148C329.609 8.80148 284.483 52.1619 284.483 105.65C284.483 159.138 329.609 202.498 385.273 202.498Z",
    stroke: "#FF9800",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeDasharray: "12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.238 143.075C419.896 138.639 417.477 132.78 417.471 126.69C417.496 122.49 418.653 118.367 420.829 114.723C423.005 111.08 426.125 108.04 429.887 105.9C428.204 103.552 427.301 100.769 427.295 97.9179C427.295 89.888 434.306 83.38 442.956 83.38C446.298 83.3472 449.561 84.3468 452.266 86.2313C454.971 88.1158 456.975 90.7856 457.981 93.8471C460.116 90.619 463.07 87.965 466.565 86.1341C470.06 84.3033 473.981 83.3556 477.962 83.38C490.848 83.38 501.299 93.0808 501.299 105.043C501.3 107.598 500.816 110.132 499.87 112.52C500.34 112.488 500.817 112.45 501.299 112.45C511.643 112.45 520.028 120.236 520.028 129.841C520.028 130.427 519.997 131.013 519.934 131.597C528.207 134.906 534 142.543 534 151.435C534 163.36 523.589 173.028 510.741 173.028C509.391 173.027 508.045 172.916 506.715 172.699C506.781 173.417 506.825 174.146 506.825 174.88C506.825 188.263 495.14 199.114 480.725 199.114C475.434 199.129 470.259 197.626 465.861 194.798C462.303 197.601 457.841 199.127 453.24 199.114C442.469 199.114 433.741 191.009 433.741 181.021C433.741 180.59 433.78 180.164 433.813 179.739H433.741C422.211 179.739 412.863 171.06 412.863 160.353C412.887 156.739 413.966 153.204 415.977 150.149C417.988 147.095 420.85 144.644 424.238 143.075Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.348 142.995C422.195 138.748 419.881 133.141 419.874 127.313C419.898 123.292 421.005 119.345 423.088 115.857C425.171 112.37 428.158 109.46 431.759 107.411C430.144 105.159 429.279 102.489 429.278 99.7537C429.278 92.0697 435.99 85.8384 444.269 85.8384C447.468 85.8079 450.593 86.7642 453.185 88.5668C455.777 90.3694 457.698 92.9233 458.668 95.8532C460.71 92.7703 463.532 90.2352 466.87 88.4847C470.208 86.7343 473.954 85.8256 477.757 85.8438C490.095 85.8438 500.091 95.1295 500.091 106.597C500.093 109.043 499.629 111.468 498.723 113.754C499.178 113.722 499.632 113.69 500.091 113.69C509.993 113.69 518.018 121.14 518.018 130.335C518.016 130.897 517.985 131.458 517.923 132.017C525.843 135.21 531.386 142.495 531.386 151.003C531.386 162.418 521.418 171.672 509.124 171.672C507.825 171.672 506.528 171.567 505.247 171.358C505.314 172.044 505.352 172.741 505.352 173.444C505.352 186.252 494.166 196.634 480.371 196.634C475.307 196.647 470.354 195.209 466.144 192.505C462.752 195.181 458.499 196.644 454.11 196.645C443.804 196.645 435.447 188.886 435.447 179.318C435.447 178.903 435.48 178.499 435.514 178.089H435.447C424.41 178.089 415.461 169.783 415.461 159.534C415.484 156.074 416.516 152.69 418.441 149.767C420.366 146.843 423.105 144.497 426.348 142.995Z",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.219 118.735H464.914V247.634H472.219V118.735Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.713 118.735H466.67V247.634H470.713V118.735Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.591 132.505L443.704 135.224L467.659 158.704L470.546 155.985L446.591 132.505Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.772 159.173L467.94 175.918L470.262 179.098L495.094 162.353L492.772 159.173Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.468 145.336C474.959 142.599 476.809 139.38 477.893 135.896C478.977 132.413 479.271 128.746 478.754 125.144C478.237 121.543 476.921 118.089 474.895 115.018C472.87 111.947 470.182 109.329 467.013 107.342C468.652 104.905 469.522 102.064 469.516 99.1631C469.516 90.9576 462.749 84.3059 454.398 84.3059C451.098 84.3293 447.896 85.3863 445.277 87.3166C442.659 89.2468 440.767 91.945 439.888 95.0018C437.921 91.759 435.107 89.0663 431.724 87.1903C428.341 85.3142 424.506 84.3199 420.6 84.3059C408.156 84.3059 398.066 94.2195 398.066 106.448C398.063 109.053 398.53 111.638 399.445 114.089C398.991 114.057 398.531 114.02 398.066 114.02C388.098 114.02 379.979 122.002 379.979 131.793C379.979 132.4 380.012 132.996 380.073 133.587C376.008 135.338 372.56 138.186 370.148 141.786C367.736 145.385 366.465 149.58 366.489 153.861C366.489 166.052 376.546 175.934 388.945 175.934C390.245 175.932 391.542 175.82 392.822 175.599C392.755 176.333 392.716 177.078 392.716 177.828C392.716 191.504 403.997 202.594 417.92 202.594C423.064 202.595 428.08 201.053 432.268 198.182C435.639 201.023 439.968 202.591 444.452 202.594C454.852 202.594 463.281 194.309 463.281 184.092C463.281 183.65 463.242 183.214 463.214 182.777H463.281C474.417 182.777 483.439 173.907 483.439 162.966C483.456 159.346 482.443 155.79 480.51 152.682C478.576 149.575 475.795 147.035 472.468 145.336Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.555 145.219C471.891 142.65 473.626 139.629 474.642 136.36C475.659 133.091 475.934 129.651 475.448 126.271C474.963 122.892 473.728 119.652 471.828 116.77C469.927 113.888 467.406 111.431 464.433 109.566C465.971 107.278 466.786 104.611 466.781 101.888C466.781 94.1823 460.429 87.9404 452.587 87.9404C449.494 87.9671 446.494 88.961 444.041 90.7717C441.588 92.5824 439.815 95.1115 438.991 97.9764C437.145 94.9316 434.503 92.4032 431.326 90.6419C428.15 88.8806 424.55 87.9475 420.882 87.9351C409.203 87.9351 399.733 97.2421 399.733 108.72C399.73 111.165 400.169 113.592 401.029 115.893C400.602 115.861 400.17 115.829 399.733 115.829C390.357 115.829 382.759 123.279 382.759 132.512C382.759 133.081 382.787 133.64 382.848 134.193C379.035 135.841 375.803 138.517 373.542 141.896C371.281 145.274 370.089 149.211 370.111 153.228C370.111 164.669 379.525 173.944 391.194 173.944C392.417 173.943 393.639 173.838 394.843 173.63C394.782 174.322 394.743 175.019 394.743 175.721C394.743 188.562 405.332 198.965 418.396 198.965C423.224 198.967 427.933 197.519 431.864 194.825C435.028 197.491 439.092 198.962 443.3 198.965C453.058 198.965 460.971 191.19 460.971 181.596C460.971 181.181 460.938 180.771 460.91 180.361H460.971C471.421 180.361 479.894 172.033 479.894 161.763C479.908 158.361 478.951 155.021 477.129 152.104C475.306 149.188 472.687 146.806 469.555 145.219Z",
    fill: "#00897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.241 118.687H426.747V250.007H432.241V118.687Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.072 120.534H428.309V250.007H431.072V120.534Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.73 135.127L428.048 158.663L430.076 160.467L452.758 136.931L450.73 135.127Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.386 161.985L404.738 164.117L428.253 180.898L429.901 178.766L406.386 161.985Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.616 183.735C363.658 180.708 362.01 176.713 362.009 172.56C362.026 169.698 362.815 166.889 364.298 164.407C365.781 161.924 367.907 159.853 370.471 158.395C369.321 156.791 368.705 154.889 368.704 152.94C368.704 147.47 373.483 143.032 379.376 143.032C381.652 143.01 383.876 143.691 385.719 144.975C387.563 146.258 388.928 148.077 389.615 150.163C391.071 147.963 393.084 146.155 395.466 144.908C397.848 143.661 400.52 143.015 403.233 143.032C412.016 143.032 419.138 149.641 419.138 157.794C419.139 159.536 418.809 161.263 418.163 162.891C418.484 162.891 418.806 162.843 419.138 162.843C426.188 162.843 431.875 168.165 431.875 174.694C431.875 175.094 431.852 175.494 431.809 175.891C434.62 176.98 437.031 178.847 438.738 181.254C440.445 183.661 441.369 186.5 441.395 189.413C441.395 197.539 434.301 204.126 425.545 204.126C424.617 204.127 423.691 204.052 422.776 203.903C422.826 204.392 422.854 204.887 422.854 205.388C422.854 214.508 414.89 221.884 405.066 221.884C401.481 221.9 397.972 220.894 394.981 218.994C392.553 220.895 389.513 221.926 386.381 221.91C379.043 221.91 373.09 216.387 373.09 209.575C373.09 209.277 373.09 208.99 373.14 208.703H373.09C365.232 208.703 358.863 202.791 358.863 195.495C358.883 193.035 359.619 190.629 360.99 188.55C362.36 186.471 364.309 184.803 366.616 183.735Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.051 183.682C365.214 180.791 363.63 176.97 363.62 172.997C363.637 170.257 364.392 167.568 365.812 165.191C367.232 162.815 369.268 160.833 371.722 159.438C370.622 157.902 370.033 156.082 370.033 154.218C370.033 148.981 374.607 144.735 380.245 144.735C382.425 144.713 384.554 145.365 386.319 146.594C388.084 147.823 389.391 149.565 390.047 151.562C391.44 149.457 393.366 147.726 395.645 146.532C397.924 145.338 400.482 144.72 403.078 144.735C411.484 144.735 418.302 151.062 418.302 158.868C418.304 160.536 417.988 162.19 417.371 163.748C417.681 163.748 417.986 163.706 418.302 163.706C425.047 163.706 430.518 168.782 430.518 175.045C430.519 175.427 430.498 175.809 430.457 176.189C433.148 177.232 435.456 179.018 437.09 181.322C438.723 183.626 439.609 186.343 439.634 189.131C439.634 196.911 432.839 203.216 424.46 203.216C423.58 203.216 422.702 203.145 421.835 203.004C421.879 203.472 421.907 203.945 421.907 204.424C421.907 213.151 414.287 220.229 404.883 220.229C401.433 220.237 398.059 219.257 395.192 217.414C392.872 219.241 389.963 220.237 386.963 220.229C379.94 220.229 374.225 214.945 374.225 208.421C374.225 208.139 374.225 207.862 374.27 207.585H374.225C366.705 207.585 360.608 201.923 360.608 194.942C360.627 192.584 361.336 190.278 362.651 188.288C363.967 186.297 365.838 184.701 368.051 183.682Z",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.312 167.148H394.333V254.988H399.312V167.148Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.282 167.148H395.53V254.988H398.282V167.148Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.843 176.529L379.878 178.38L396.199 194.379L398.164 192.527L381.843 176.529Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.321 194.701L396.399 206.111L397.98 208.276L414.902 196.865L413.321 194.701Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.45 186.343C415.126 184.507 416.37 182.347 417.1 180.008C417.83 177.67 418.028 175.208 417.681 172.789C417.334 170.371 416.449 168.052 415.088 165.991C413.726 163.93 411.92 162.174 409.79 160.843C410.882 159.204 411.459 157.297 411.451 155.351C411.511 152.976 410.663 150.661 409.068 148.845C407.474 147.029 405.242 145.837 402.795 145.493C400.348 145.149 397.855 145.678 395.786 146.979C393.717 148.281 392.216 150.265 391.565 152.557C390.245 150.382 388.357 148.576 386.088 147.317C383.82 146.058 381.248 145.39 378.628 145.379C370.277 145.379 363.504 152.031 363.504 160.241C363.501 161.99 363.814 163.725 364.429 165.371C364.124 165.371 363.814 165.323 363.504 165.323C361.892 165.341 360.299 165.663 358.816 166.272C357.333 166.881 355.99 167.765 354.863 168.872C353.735 169.98 352.846 171.291 352.246 172.729C351.646 174.167 351.346 175.704 351.365 177.254C351.365 177.658 351.365 178.063 351.426 178.456C348.697 179.632 346.382 181.545 344.764 183.961C343.146 186.378 342.293 189.195 342.31 192.068C342.31 200.247 349.061 206.883 357.385 206.883C358.259 206.882 359.132 206.808 359.993 206.659C359.949 207.154 359.921 207.649 359.921 208.155C359.921 217.334 367.497 224.778 376.834 224.778C380.286 224.78 383.653 223.746 386.464 221.82C388.727 223.726 391.634 224.777 394.644 224.778C396.322 224.76 397.981 224.425 399.524 223.791C401.068 223.157 402.466 222.237 403.64 221.084C404.813 219.93 405.739 218.566 406.364 217.069C406.988 215.572 407.3 213.971 407.281 212.359C407.281 212.061 407.281 211.768 407.237 211.475H407.281C414.757 211.475 420.816 205.521 420.816 198.172C420.827 195.742 420.146 193.356 418.848 191.271C417.55 189.186 415.684 187.482 413.45 186.343Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.496 186.268C413.066 184.543 414.232 182.514 414.916 180.318C415.6 178.123 415.785 175.812 415.459 173.541C415.133 171.271 414.303 169.095 413.026 167.159C411.749 165.223 410.054 163.574 408.057 162.322C409.089 160.787 409.637 158.998 409.635 157.171C409.691 154.941 408.895 152.768 407.398 151.063C405.901 149.358 403.807 148.238 401.51 147.916C399.213 147.593 396.872 148.089 394.93 149.311C392.987 150.533 391.577 152.395 390.966 154.548C389.727 152.504 387.953 150.808 385.821 149.626C383.689 148.445 381.272 147.819 378.811 147.811C370.969 147.811 364.617 154.058 364.617 161.763C364.615 163.405 364.909 165.034 365.486 166.579C365.199 166.579 364.933 166.536 364.617 166.536C361.565 166.57 358.652 167.766 356.517 169.861C354.381 171.956 353.197 174.779 353.226 177.711C353.226 178.094 353.226 178.472 353.281 178.839C350.72 179.943 348.549 181.737 347.03 184.004C345.511 186.272 344.71 188.914 344.725 191.611C344.725 199.289 351.06 205.515 358.874 205.515C359.695 205.514 360.514 205.443 361.322 205.302C361.278 205.765 361.256 206.234 361.256 206.707C361.256 215.322 368.366 222.309 377.133 222.309C380.375 222.312 383.537 221.34 386.176 219.532C388.299 221.323 391.027 222.31 393.852 222.309C397.033 222.274 400.069 221.027 402.293 218.842C404.518 216.657 405.748 213.712 405.714 210.656C405.714 210.379 405.714 210.124 405.67 209.831H405.714C407.401 209.813 409.068 209.476 410.62 208.838C412.171 208.201 413.577 207.277 414.757 206.117C415.937 204.958 416.867 203.587 417.495 202.082C418.123 200.577 418.437 198.968 418.418 197.347C418.423 195.07 417.781 192.835 416.561 190.882C415.341 188.93 413.589 187.334 411.496 186.268Z",
    fill: "#00897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.453 168.458H382.765V256.6H386.453V168.458Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.667 169.697H383.811V256.6H385.667V169.697Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.857 179.486L383.633 195.283L384.994 196.494L400.218 180.697L398.857 179.486Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.092 197.52L367.986 198.951L383.769 210.214L384.876 208.783L369.092 197.52Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.599 125.227H224.43V258.792H380.599V125.227Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.723 125.227H121.978V254.535H376.723V125.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.912 137.998H138.598V75.2064H379.774C382.198 75.2064 384.522 76.1315 386.236 77.7781C387.949 79.4247 388.912 81.658 388.912 83.9866V137.998Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.592 77.6915H377.62C380.044 77.6915 382.368 78.6165 384.081 80.2631C385.795 81.9098 386.758 84.143 386.758 86.4717V136.38H138.592V77.6915Z",
    fill: "#92140C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M138.592 77.6915H377.62C380.044 77.6915 382.368 78.6165 384.081 80.2631C385.795 81.9098 386.758 84.143 386.758 86.4717V136.38H138.592V77.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.038 7.08801L51.6467 65.5482V114.808V258.787H224.43V114.808V65.5482L138.038 7.08801Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.553 64.5637L138.592 7.08801L56.6308 64.5637V112.983H220.553V64.5637Z",
    fill: "#92140C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M220.553 64.5637L138.592 7.08801L56.6308 64.5637V112.983H220.553V64.5637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.553 112.988H56.6308V254.535H220.553V112.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.076 93.2936L138.592 29.8367L45.0012 93.2936L38.9095 70.976L138.592 1.26116L238.275 70.976L231.076 93.2936Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.228 90.0263L138.592 25.9415L46.9616 90.0263L43.0463 69.9596L138.592 3.14491L234.143 69.9596L230.228 90.0263Z",
    fill: "#92140C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.228 90.0263L138.592 25.9415L46.9616 90.0263L43.0463 69.9596L138.592 3.14491L234.143 69.9596L230.228 90.0263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.111 143.852H92.0735V254.535H185.111V143.852Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.111 143.852H92.0735V163.008H185.111V143.852Z",
    fill: "#92140C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.111 235.379H92.0735V254.535H185.111V235.379Z",
    fill: "#92140C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.396 214.737C294.616 214.737 294.828 214.653 294.984 214.503C295.139 214.354 295.227 214.151 295.227 213.939C295.227 213.727 295.139 213.524 294.984 213.375C294.828 213.225 294.616 213.141 294.396 213.141C294.176 213.141 293.965 213.225 293.809 213.375C293.653 213.524 293.565 213.727 293.565 213.939C293.565 214.151 293.653 214.354 293.809 214.503C293.965 214.653 294.176 214.737 294.396 214.737Z",
    fill: "#00FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.913 173.651H271.502V254.535H316.913V173.651Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.185 156.623H328.543V186.422H371.185V156.623Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M371.185 156.623H328.543V169.926H371.185V156.623Z",
    fill: "#92140C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6152 199.598C31.1379 197.082 29.7516 193.754 29.7387 190.291C29.7554 187.905 30.4138 185.564 31.65 183.495C32.8863 181.426 34.6583 179.7 36.794 178.483C35.8357 177.146 35.322 175.562 35.3209 173.938C35.3617 171.71 36.3214 169.589 37.989 168.04C39.6567 166.492 41.896 165.643 44.2148 165.68C46.1164 165.659 47.9743 166.227 49.5141 167.299C51.0539 168.372 52.1938 169.892 52.7654 171.634C53.979 169.801 55.6574 168.294 57.6431 167.254C59.6288 166.214 61.8568 165.676 64.1181 165.69C71.4393 165.69 77.3759 171.203 77.3759 177.999C77.3773 179.454 77.1014 180.896 76.5618 182.256C76.8332 182.256 77.1156 182.218 77.3759 182.218C83.2516 182.218 88.0143 186.64 88.0143 192.095C88.0136 192.427 87.9952 192.759 87.9589 193.09C90.3022 193.998 92.3124 195.553 93.7349 197.56C95.1575 199.566 95.9284 201.933 95.9501 204.361C95.9501 211.135 90.0356 216.626 82.7366 216.626C81.9702 216.626 81.2051 216.563 80.4495 216.44C80.4882 216.85 80.5104 217.259 80.5104 217.68C80.5104 225.284 73.8649 231.446 65.6854 231.446C62.679 231.454 59.7385 230.6 57.24 228.993C55.2184 230.586 52.6829 231.453 50.0684 231.446C43.9767 231.446 38.9926 226.843 38.9926 221.16C38.9926 220.915 38.9926 220.67 39.0313 220.431H38.9926C32.4412 220.431 27.1303 215.498 27.1303 209.421C27.1444 207.364 27.7599 205.353 28.9065 203.616C30.0531 201.879 31.6848 200.487 33.6152 199.598Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7948 199.555C32.4361 197.143 31.1214 193.958 31.1176 190.647C31.1313 188.364 31.7603 186.122 32.9434 184.142C34.1264 182.161 35.8231 180.508 37.8683 179.345C36.9514 178.064 36.4609 176.546 36.4617 174.992C36.4804 173.935 36.7156 172.893 37.1538 171.923C37.592 170.954 38.2247 170.077 39.0156 169.343C39.8066 168.609 40.7403 168.031 41.7635 167.644C42.7867 167.256 43.8794 167.066 44.979 167.085C46.7951 167.067 48.569 167.61 50.0395 168.635C51.51 169.659 52.5995 171.109 53.1475 172.773C54.3088 171.018 55.9151 169.576 57.8157 168.581C59.7162 167.586 61.8486 167.071 64.0129 167.085C71.0183 167.085 76.7002 172.358 76.7002 178.866C76.7017 180.255 76.4389 181.633 75.9249 182.932C76.1797 182.932 76.44 182.894 76.7002 182.894C82.3268 182.894 86.8845 187.151 86.8845 192.35C86.885 192.668 86.8683 192.986 86.8347 193.303C89.0766 194.173 90.9995 195.663 92.3598 197.584C93.7202 199.505 94.457 201.771 94.477 204.094C94.477 210.581 88.8172 215.839 81.8284 215.839C81.086 215.839 80.3449 215.778 79.6132 215.658C79.652 216.046 79.6741 216.445 79.6741 216.844C79.6741 224.119 73.3221 230.02 65.4804 230.02C62.6131 230.02 59.8104 229.202 57.4283 227.668C55.4941 229.192 53.0681 230.022 50.5668 230.015C44.7132 230.015 39.9672 225.609 39.9672 220.17C39.9672 219.936 39.9672 219.702 40.0059 219.473H39.9672C33.6983 219.473 28.6144 214.753 28.6144 208.932C28.6308 206.97 29.2184 205.052 30.3107 203.395C31.403 201.738 32.9563 200.408 34.7948 199.555Z",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8563 185.773H56.7028V259H60.8563V185.773Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9923 185.773H57.6996V259H59.9923V185.773Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2895 193.591L44.6523 195.134L58.2597 208.472L59.8969 206.929L46.2895 193.591Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5314 208.743L58.4245 218.255L59.7415 220.059L73.8484 210.546L72.5314 208.743Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4793 199.598C4.002 197.082 2.61571 193.754 2.60275 190.291C2.61945 187.905 3.27788 185.564 4.51411 183.495C5.75034 181.426 7.52235 179.7 9.65807 178.483C8.69973 177.146 8.18606 175.562 8.18498 173.938C8.22576 171.71 9.18542 169.589 10.8531 168.04C12.5208 166.492 14.7601 165.643 17.0789 165.68C18.9804 165.659 20.8384 166.227 22.3782 167.299C23.918 168.372 25.0579 169.892 25.6294 171.634C26.8431 169.801 28.5215 168.294 30.5072 167.254C32.4929 166.214 34.7209 165.676 36.9822 165.69C44.3033 165.69 50.24 171.203 50.24 177.999C50.2414 179.454 49.9655 180.896 49.4259 182.256C49.6973 182.256 49.9797 182.218 50.24 182.218C56.1157 182.218 60.8783 186.64 60.8783 192.095C60.8777 192.427 60.8592 192.759 60.823 193.09C63.1662 193.998 65.1764 195.553 66.599 197.56C68.0216 199.566 68.7925 201.933 68.8142 204.361C68.8142 211.135 62.8997 216.626 55.6007 216.626C54.8342 216.626 54.0692 216.563 53.3135 216.44C53.3523 216.85 53.3744 217.259 53.3744 217.68C53.3744 225.284 46.7289 231.446 38.5494 231.446C35.543 231.454 32.6026 230.6 30.1041 228.993C28.0825 230.586 25.5469 231.453 22.9325 231.446C16.8408 231.446 11.8566 226.843 11.8566 221.16C11.8566 220.915 11.8566 220.67 11.8954 220.431H11.8566C5.30526 220.431 -0.00561523 215.498 -0.00561523 209.421C0.00848373 207.364 0.62396 205.353 1.77059 203.616C2.91722 201.879 4.54884 200.487 6.4793 199.598Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65896 199.555C5.30031 197.143 3.98561 193.958 3.98178 190.647C3.99551 188.364 4.62453 186.122 5.80757 184.142C6.99061 182.161 8.68734 180.508 10.7325 179.345C9.81564 178.064 9.32512 176.546 9.32588 174.992C9.34462 173.935 9.57982 172.893 10.018 171.923C10.4562 170.954 11.0889 170.077 11.8798 169.343C12.6708 168.609 13.6045 168.031 14.6277 167.644C15.6509 167.256 16.7436 167.066 17.8432 167.085C19.6593 167.067 21.4331 167.61 22.9037 168.635C24.3742 169.659 25.4637 171.109 26.0116 172.773C27.173 171.018 28.7793 169.576 30.6799 168.581C32.5804 167.586 34.7128 167.071 36.8771 167.085C43.8825 167.085 49.5644 172.358 49.5644 178.866C49.5659 180.255 49.3031 181.633 48.7891 182.932C49.0439 182.932 49.3042 182.894 49.5644 182.894C55.191 182.894 59.7487 187.151 59.7487 192.35C59.7491 192.668 59.7325 192.986 59.6988 193.303C61.9408 194.173 63.8636 195.663 65.224 197.584C66.5844 199.505 67.3212 201.771 67.3412 204.094C67.3412 210.581 61.6814 215.839 54.6926 215.839C53.9502 215.839 53.2091 215.778 52.4774 215.658C52.5162 216.046 52.5383 216.445 52.5383 216.844C52.5383 224.119 46.1863 230.02 38.3446 230.02C35.4773 230.02 32.6746 229.202 30.2925 227.668C28.3583 229.192 25.9323 230.022 23.431 230.015C17.5774 230.015 12.8314 225.609 12.8314 220.17C12.8314 219.936 12.8314 219.702 12.8701 219.473H12.8314C6.56245 219.473 1.47864 214.753 1.47864 208.932C1.49499 206.97 2.08258 205.052 3.17486 203.395C4.26715 201.738 5.82048 200.408 7.65896 199.555Z",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7204 185.773H29.567V259H33.7204V185.773Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8565 185.773H30.5638V259H32.8565V185.773Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1585 193.592L17.5213 195.135L31.1287 208.473L32.7659 206.93L19.1585 193.592Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3961 208.747L31.2892 218.259L32.6062 220.062L46.7131 210.55L45.3961 208.747Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2107 200.178C69.6092 198.646 70.6485 196.843 71.2582 194.891C71.8678 192.939 72.0336 190.884 71.7442 188.866C71.4548 186.847 70.717 184.912 69.5808 183.191C68.4447 181.47 66.9367 180.004 65.1593 178.893C66.0763 177.529 66.5629 175.94 66.5603 174.316C66.6113 172.335 65.9053 170.404 64.5759 168.889C63.2465 167.374 61.3856 166.379 59.3448 166.092C57.304 165.805 55.2244 166.246 53.499 167.332C51.7736 168.418 50.5217 170.073 49.9798 171.986C48.8792 170.171 47.3043 168.664 45.4112 167.614C43.518 166.564 41.3723 166.007 39.1864 165.999C37.5113 166.015 35.856 166.348 34.3152 166.98C32.7744 167.611 31.3784 168.529 30.207 169.68C29.0357 170.83 28.1121 172.192 27.4892 173.686C26.8662 175.18 26.5561 176.778 26.5765 178.387C26.5765 179.838 26.8369 181.278 27.3463 182.644C27.0916 182.644 26.8368 182.607 26.5765 182.607C25.2274 182.62 23.8942 182.889 22.6538 183.4C21.4134 183.91 20.2902 184.65 19.3488 185.579C18.4074 186.508 17.6665 187.606 17.1686 188.811C16.6707 190.016 16.4257 191.304 16.4477 192.6C16.4477 192.941 16.4477 193.276 16.4975 193.606C14.2234 194.587 12.2946 196.181 10.9458 198.195C9.59688 200.209 8.88598 202.556 8.89947 204.951C8.86841 208.188 10.1732 211.305 12.5281 213.62C14.8831 215.935 18.0965 217.259 21.465 217.302C22.1948 217.302 22.9231 217.239 23.6414 217.116C23.6027 217.526 23.5805 217.941 23.5805 218.361C23.5805 226.013 29.8937 232.196 37.6801 232.196C40.5588 232.196 43.3656 231.333 45.7101 229.727C47.596 231.317 50.0185 232.194 52.5272 232.196C55.3503 232.163 58.044 231.054 60.0168 229.113C61.9897 227.173 63.0803 224.559 63.0493 221.846C63.0493 221.596 63.0493 221.357 63.0105 221.112H63.0493C66.0745 221.078 68.9621 219.892 71.0773 217.814C73.1926 215.735 74.3626 212.935 74.3301 210.028C74.339 208.006 73.7739 206.021 72.6956 204.285C71.6172 202.55 70.0666 201.13 68.2107 200.178Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5825 200.114C67.8906 198.676 68.8623 196.985 69.4317 195.156C70.0011 193.326 70.1551 191.4 69.8831 189.508C69.6111 187.616 68.9196 185.803 67.8553 184.19C66.791 182.577 65.3787 181.202 63.7138 180.159C64.5735 178.879 65.0293 177.388 65.0263 175.865C65.0779 174.003 64.4172 172.188 63.1695 170.763C61.9218 169.338 60.1736 168.403 58.256 168.133C56.3384 167.864 54.3845 168.279 52.7643 169.301C51.1442 170.323 49.9702 171.88 49.4648 173.678C48.4314 171.974 46.9526 170.559 45.175 169.573C43.3974 168.588 41.3827 168.066 39.3304 168.058C36.1607 168.1 33.1377 169.349 30.9243 171.529C28.711 173.71 27.488 176.645 27.5235 179.691C27.5223 181.058 27.7678 182.416 28.249 183.703C28.0108 183.703 27.7672 183.666 27.5235 183.666C24.9761 183.694 22.5446 184.693 20.7636 186.443C18.9826 188.193 17.9979 190.552 18.026 193C18.026 193.319 18.026 193.633 18.0758 193.941C15.9418 194.861 14.1317 196.356 12.8655 198.245C11.5992 200.135 10.9313 202.337 10.9429 204.584C10.909 207.624 12.1324 210.552 14.3442 212.725C16.5561 214.898 19.5754 216.139 22.7387 216.174C23.424 216.174 24.1078 216.115 24.7822 215.998C24.749 216.387 24.7268 216.775 24.7268 217.169C24.7268 224.353 30.6524 230.174 37.9625 230.174C40.6645 230.176 43.2995 229.367 45.4996 227.86C47.2688 229.347 49.5395 230.168 51.8904 230.169C53.2038 230.155 54.5015 229.893 55.7094 229.397C56.9173 228.901 58.0118 228.181 58.9302 227.279C59.8487 226.377 60.5732 225.31 61.0623 224.138C61.5515 222.967 61.7957 221.714 61.7811 220.452C61.7811 220.218 61.7811 219.989 61.7479 219.76H61.7811C63.1876 219.745 64.5772 219.464 65.8706 218.932C67.164 218.401 68.3357 217.63 69.319 216.664C70.3022 215.697 71.0777 214.554 71.6011 213.299C72.1246 212.045 72.3857 210.703 72.3696 209.352C72.3723 207.452 71.8347 205.587 70.8148 203.959C69.7948 202.331 68.3314 201.001 66.5825 200.114Z",
    fill: "#00897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.699 185.268H42.6254V258.75H45.699V185.268Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0455 186.3H43.5004V258.75H45.0455V186.3Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0589 194.463L43.3674 207.633L44.501 208.642L57.1926 195.472L56.0589 194.463Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2296 209.494L30.3083 210.686L43.4684 220.077L44.3896 218.885L31.2296 209.494Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.037 28.086C387.205 20.2569 377.822 14.0124 367.441 9.7201C357.06 5.42779 345.89 3.17441 334.589 3.09259C323.288 3.01078 312.084 5.10218 301.637 9.2437C291.189 13.3852 281.71 19.4932 273.756 27.208C241.686 58.2739 241.143 108.853 272.51 140.552C286.288 154.496 304.757 163.304 324.646 165.417C344.535 167.529 364.561 162.81 381.175 152.094L442.425 213.29C442.8 213.665 443.248 213.966 443.744 214.175C444.241 214.384 444.775 214.497 445.316 214.508C445.858 214.518 446.397 214.426 446.901 214.236C447.405 214.046 447.866 213.763 448.256 213.401L463.513 199.305C463.904 198.945 464.217 198.514 464.435 198.037C464.652 197.56 464.77 197.047 464.781 196.527C464.792 196.006 464.696 195.489 464.498 195.004C464.3 194.519 464.005 194.077 463.63 193.702L402.38 132.507C414.124 117.048 419.826 98.1081 418.483 79.0123C417.14 59.9165 408.839 41.8857 395.037 28.086ZM375.959 126.488C367.321 134.472 356.413 139.816 344.614 141.843C332.815 143.871 320.656 142.491 309.674 137.878C298.691 133.265 289.379 125.627 282.915 115.928C276.45 106.23 273.124 94.9075 273.356 83.3926C273.588 71.8778 277.369 60.6877 284.22 51.2375C291.071 41.7872 300.684 34.5012 311.844 30.3009C323.005 26.1006 335.21 25.1745 346.918 27.6398C358.626 30.1051 369.311 35.8511 377.62 44.1511C383.137 49.6622 387.471 56.1636 390.374 63.284C393.276 70.4045 394.691 78.0045 394.536 85.6502C394.382 93.296 392.662 100.838 389.474 107.845C386.287 114.852 381.694 121.187 375.959 126.488Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.074 68.3206C282.257 68.3206 282.246 78.495 289.074 78.495C295.902 78.495 295.897 68.3206 289.074 68.3206Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.578 35.7221C318.237 35.323 301.54 44.1671 292.668 57.5396C289.772 61.8924 297.996 65.7398 300.875 61.4082C308.224 50.3558 322.191 43.3157 337.282 43.7041C353.109 44.0873 367.513 52.7876 375.139 64.8617C378.035 69.4434 385.611 65.2768 382.737 60.7218C373.483 46.0508 355.529 36.1319 336.578 35.7221Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.682 24.989C393.851 17.1599 384.468 10.9154 374.087 6.62308C363.706 2.33077 352.536 0.0773855 341.235 -0.0044299C329.933 -0.0862453 318.729 2.00516 308.282 6.14668C297.835 10.2882 288.355 16.3961 280.402 24.111C248.332 55.1769 247.789 105.756 279.156 137.455C292.934 151.399 311.403 160.207 331.292 162.32C351.181 164.432 371.206 159.713 387.821 148.997L449.07 210.193C449.445 210.568 449.894 210.869 450.39 211.078C450.886 211.287 451.42 211.4 451.962 211.411C452.504 211.421 453.042 211.329 453.547 211.139C454.051 210.949 454.512 210.666 454.902 210.304L470.164 196.203C470.555 195.843 470.869 195.412 471.086 194.935C471.304 194.458 471.421 193.945 471.432 193.424C471.443 192.904 471.347 192.387 471.149 191.902C470.951 191.417 470.656 190.975 470.281 190.6L409.031 129.404C420.773 113.946 426.473 95.0064 425.129 75.9117C423.785 56.8171 415.484 38.7877 401.682 24.989ZM382.604 123.391C373.966 131.375 363.058 136.719 351.26 138.746C339.461 140.774 327.302 139.394 316.319 134.781C305.337 130.168 296.025 122.53 289.56 112.831C283.096 103.133 279.769 91.8105 280.001 80.2956C280.234 68.7808 284.014 57.5907 290.865 48.1404C297.716 38.6902 307.33 31.4042 318.49 27.2039C329.65 23.0036 341.856 22.0775 353.564 24.5428C365.272 27.0081 375.956 32.7541 384.266 41.0541C389.783 46.5652 394.117 53.0666 397.019 60.187C399.922 67.3075 401.336 74.9075 401.182 82.5532C401.027 90.199 399.307 97.7406 396.12 104.748C392.932 111.755 388.34 118.09 382.604 123.391Z",
    fill: "#92140C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.72 65.2076C288.902 65.2076 288.891 75.382 295.72 75.382C302.548 75.382 302.542 65.2076 295.72 65.2076Z",
    fill: "#92140C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.224 32.6251C324.882 32.226 308.186 41.0701 299.314 54.4426C296.417 58.7954 304.641 62.6427 307.521 58.3112C314.87 47.2588 328.837 40.2186 343.927 40.6071C359.755 40.9902 374.159 49.6906 381.785 61.7647C384.681 66.3464 392.257 62.1798 389.383 57.6247C380.129 42.9645 362.175 33.0402 343.224 32.6251Z",
    fill: "#92140C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 473.437,
    y1: 199.098,
    x2: 473.437,
    y2: 83.3587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 6645.35,
    y1: 60104.3,
    x2: 6645.35,
    y2: 28879.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 107222,
    y1: 74628.2,
    x2: 107222,
    y2: 48332.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 4687.33,
    y1: 61815.4,
    x2: 4687.33,
    y2: 29408.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 72066.5,
    y1: 52714.2,
    x2: 72066.5,
    y2: 41023.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 3961.8,
    y1: 42258,
    x2: 3961.8,
    y2: 27758.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 65919.2,
    y1: 53491.6,
    x2: 65919.2,
    y2: 41644.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 2944.26,
    y1: 42671.7,
    x2: 2944.26,
    y2: 28071.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 85533.6,
    y1: 65082.1,
    x2: 85533.6,
    y2: 31557.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 155977,
    y1: 32023,
    x2: 155977,
    y2: 24613.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 43119.6,
    y1: 122416,
    x2: 43119.6,
    y2: 3362.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 49932.1,
    y1: 16137.3,
    x2: 49932.1,
    y2: 219.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 17743.4,
    y1: 45174.4,
    x2: 17743.4,
    y2: 37048.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 497.549,
    y1: 35826.8,
    x2: 497.549,
    y2: 25750,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 14344.1,
    y1: 45174.4,
    x2: 14344.1,
    y2: 37048.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 266.895,
    y1: 35826.8,
    x2: 266.895,
    y2: 25750,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 14500.7,
    y1: 45567.5,
    x2: 14500.7,
    y2: 37333.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 287.741,
    y1: 35916.1,
    x2: 287.741,
    y2: 25768.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 357.069,
    y1: 214.524,
    x2: 357.069,
    y2: 3.09701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 289.074,
    y1: 78.5003,
    x2: 289.074,
    y2: 68.3206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 69338.8,
    y1: 11714.7,
    x2: 69338.8,
    y2: 9893.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 534,
    height: 259,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawHouseSearchingN8Mp1);
export default __webpack_public_path__ + "static/media/undraw_house_searching_n8mp 1.cd8db264.svg";
export { ForwardRef as ReactComponent };